export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const dayNames = ["Su", "M", "Tu", "W", "Th", "F", "S"];

/*
 * Return array of all days in the week that the startingDate is within
 */
export function weekBuilder({
  startingDay,
  month,
  year,
  firstDayOfWeek = 0
}): Date[] {
  const thisMonth = new Date(year, month);

  const thisWeek: Date[] = [];

  const dayOfWeek = new Date(year, month, startingDay).getDay();

  const end =
    dayOfWeek >= firstDayOfWeek
      ? dayOfWeek - firstDayOfWeek
      : 7 - firstDayOfWeek + dayOfWeek;

  let daysAgo = 1;
  for (let i = 0; i < end; i++) {
    thisWeek.unshift(
      new Date(
        thisMonth.getFullYear(),
        thisMonth.getMonth(),
        startingDay - daysAgo
      )
    );
    daysAgo++;
  }

  thisWeek.push(new Date(year, month, startingDay));

  let daysForward = 1;
  while (thisWeek.length < 7) {
    thisWeek.push(new Date(year, month, startingDay + daysForward));
    daysForward++;
  }

  return thisWeek;
}

/*
 * Return array of all weeks in the specified month
 */
export function weeksInThisMonth(date: Date) {
  const month = date.getMonth();
  const year = date.getFullYear();
  const weeksInThisMonth: any = [];
  const daysInThisMonth = new Date(year, month + 1, 0).getDate();

  let startingDay = 1;

  while (startingDay <= daysInThisMonth + 6) {
    const newWeek = weekBuilder({ startingDay, month, year });
    let weekValid = false;

    newWeek.forEach(day => {
      if (day.getMonth() === month) {
        weekValid = true;
      }
    });

    if (weekValid) {
      weeksInThisMonth.push(newWeek);
    }

    startingDay += 7;
  }

  return weeksInThisMonth;
}

/*
 * Returns an array of years for the year dropdown
 */
export function listOfYears({
  yearsRange = [1970, new Date().getFullYear() + 20]
}) {
  const latestYear = Math.max(...yearsRange);
  const earliestYear = Math.min(...yearsRange);
  const arrayOfYears: number[] = [];
  for (let i = earliestYear; i <= latestYear; i++) {
    arrayOfYears.push(i);
  }

  return arrayOfYears.reverse();
}
